module.exports = __webpack_public_path__ + "img/01_sub_uk.0100da86.svg";